var map = {
	"./apple.svg": 125,
	"./bigWalrus.svg": 126,
	"./cactus.svg": 127,
	"./ed.png": 128,
	"./egg.svg": 129,
	"./gameboy.svg": 130,
	"./icecream.svg": 131,
	"./logo.svg": 132,
	"./menu.svg": 133,
	"./pancake.svg": 134,
	"./poop copy.svg": 135,
	"./poop.svg": 136,
	"./search.svg": 52,
	"./trump-johnson-trudeau-sentiment.png": 137,
	"./trump-johnson-trudeau-subjectivity.png": 138,
	"./trump-johnson-trudeau-versus-health-sentiment.png": 139,
	"./trump-johnson-trudeau-versus-health-subjectivity.png": 140,
	"./walrus.svg": 141,
	"./watermelon.svg": 142
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 124;